import React from "react";

// The colours come in at run time (each category has its own), so they are set
// as inline styles. Tailwind only generates classes it can read in the source,
// so a class built as `bg-[${color}]` was never generated and the tag drew with
// no colour at all.
function Tag({ text, color, textColor }) {
  return (
    <div
      className="px-[8px] py-[3px] rounded-full text-[13px] font-semibold"
      style={{ backgroundColor: color, color: textColor }}
    >
      {text}
    </div>
  );
}

export default Tag;
